import CtaLink from './cta-link'
import { useTranslations } from '@/utils/locale'
import { SizeType } from './cta-link'
import { usePage } from '@inertiajs/react'

export default function DownloadPdfButton({
  buttonStyle,
  backgroundColor,
  btnText,
  className,
  size = 'Base',
}: {
  backgroundColor: string
  buttonStyle: string
  btnText: string
  className?: string
  size?: SizeType
}) {
  const { t } = useTranslations()

  const { url } = usePage()
  // trim params and hash
  const [path] = url.split(/[?#]/)
  // trim slashes
  const slashless = path.replace(/^\/+|\/+$/g, '')
  // replace remaining slashes with dashes and add .pdf extension
  const pdfPath = `/pdf/${slashless.replaceAll('/', '-')}.pdf`

  return (
    <a href={pdfPath} target="_blank">
      <CtaLink asButton className={className} style={buttonStyle} backgroundColor={backgroundColor} size={size}>
        <span className="font-bwi mr-2">&#xe94e;</span>
        {t(btnText)}
      </CtaLink>
    </a>
  )
}
